<span class="tooltip-wrapper"
      (mouseenter)="onMouseEnter()"
      (mouseleave)="onMouseLeave()">
    <i class="vhvicon vhvicon-tooltip"
       role="button"
       tabindex="0"
       [attr.aria-expanded]="visible"
       [attr.aria-label]="text"
       (click)="toggle($event)"
       (keydown.enter)="toggle($event)"
       (keydown.space)="toggle($event)"></i>
    @if (visible) {
        <span class="tooltip-content" role="tooltip">{{ text }}</span>
    }
</span>
